import React, { useEffect, useState } from 'react';

import styles from './HealthCardDwarfDistributionYear.module.scss';
import { useTranslate } from 'react-polyglot';
import { useAuth } from '../../../../../../../Auth';
import { useAxios } from '../../../../../../../AxiosHandler';
import LineGraphCard from '../../../../Cards/LineGraphCard/LineGraphCard';

function HealthCardDwarfDistributionYear(props: HealthCardDwarfDistributionYearProps) {
    const t = useTranslate();
    const auth = useAuth();
    const axiosHandler = useAxios();
    const axios = axiosHandler.axios;

    const [data, setData] = useState<any>();
    
    function getData() {
        if (auth.selectedBreed == undefined) return;
        axios.single({
            method: 'get',
            url: "/api/statistics/dwarf/breed/" + auth.selectedBreed + "/distributionyear",
            responseType: 'json',
            headers: { 'x-access-token': auth.user['token'], "selected-country": auth.selectedCountry || "all" }
        }).then((res) => {
            let dataSets = [
                { label: "0", color: "#68DB5A" },
                { label: "1", color: "#A6F65D" },
                { label: "2", color: "#FFE144" },
            ]

            if (res.data?.length > 0) {
                setData({
                    labels: res.data.map((i: any) => i["YEAR"]),
                    datasets: [
                        {
                            label: t("statistics.areas.health.graphs.dwarf.distributionyear.datasets.label_free"),
                            backgroundColor: "transparent",
                            pointBackgroundColor: "#68DB5A",
                            borderColor: "#68DB5A",
                            pointRadius: 2,
                            data: res.data.map((j: any) => j["FRI"]),
                            tension: 0.5
                        },
                        {
                            label: t("statistics.areas.health.graphs.dwarf.distributionyear.datasets.label_carrier"),
                            backgroundColor: "transparent",
                            pointBackgroundColor: "#FFE144",
                            borderColor: "#FFE144",
                            pointRadius: 2,
                            data: res.data.map((j: any) => j["BAERER"]),
                            tension: 0.5
                        },
                        {
                            label: t("statistics.areas.health.graphs.dwarf.distributionyear.datasets.label_afflicted"),
                            backgroundColor: "transparent",
                            pointBackgroundColor: "#ff2f45",
                            borderColor: "#ff2f45",
                            pointRadius: 2,
                            data: res.data.map((j: any) => j["AFFISERT"]),
                            tension: 0.5
                        },
                    ]
                });
            } else {
                setData(undefined);
            }
            
            props.onDataLoaded?.(res.data);
        }).catch((err) => {
            console.log(err);
        });
    }

    useEffect(() => {
        if (auth.selectedBreed != undefined) {
            getData();
        }
    }, [auth.selectedBreed, auth.selectedCountry]);

    return (
        <div className={styles.statisticshealth} style={{ display: data == undefined || data.length == 0 ? "none" : "block" }}>
            <LineGraphCard
                title={t("statistics.areas.health.graphs.dwarf.distributionyear.title")}
                data={data}
                description={t("statistics.areas.health.graphs.dwarf.distributionyear.description")}
            ></LineGraphCard>
        </div>
    );
}

class HealthCardDwarfDistributionYearProps {
    onDataLoaded?: (data: any) => void;
}

export default HealthCardDwarfDistributionYear;